import { memo } from 'react';

import useTranslation from '@Queries/useTranslation';
import GallerySection from '@Components/GallerySection';
import WikiArticle from '@Components/WikiArticle';

import type { WikiArticleData } from '@Types/Wiki';
import type { FC, HTMLAttributes } from 'react';

interface TopArticlesProps extends HTMLAttributes<HTMLDivElement> {
  articles: WikiArticleData[];
}

const TopArticles: FC<TopArticlesProps> = (props) => {
  const { articles, ...restProps } = props;
  const { t } = useTranslation();

  return (
    <GallerySection
      title={t('top')}
      defaultSizes
      slides={articles.slice(0, 10)}
      renderSlide={(article) => <WikiArticle article={article} />}
      {...restProps}
    />
  );
};

export default memo(TopArticles);
